export const columns = [
  { field: "prd_code", headerName: "Código", width: 60 },
  { field: "art_descripcion", headerName: "Artículo", width: 210 },
  { field: "price", headerName: "Precio", width: 60 },
  { field: "quantity", headerName: "Cant.", width: 40 },
  { field: "observacion", headerName: "Observación", width: 130 },
  { field: "total_amount", headerName: "Importe", width: 60 },
];

